import React from "react";

const LossLimitDocs = (
    <>
        <p>
            The Max loss you are willing to take on a position before you exit. If this
            is set to 200, then once your positions overal pnl reaches -200, we will
            flatten the position.
        </p>
        <p>mode: percent (%) or amount ($). If you are in percent mode, set the amount value to a percentage, let's say
            10%. If your cost basis is $2500, we will translate that to a $250 stop loss. If you use amount, you provide
            us the $ max amount to lose. In the above example, you would set the amount field to $250.</p>
        <p>
            NOTE: you provide us 200, not -200, for us to watch for a loss of 200. Once in a trade, if you have selected
            percent mode, it will shift to amount mode. Meaning that let's say you have a position with cost basis of
            $2500,
            and a loss limit percent of 10%, once in a trade, the lossLimit will be $250. If you want to decrease the
            loss limit
            from now on, you would not change from 10% to 8%, but rather from $250 to $240. It is much easier on the
            user to not
            have to think in terms of percentage at this point, and rather in dollar amount.
        </p>
    </>
);

export default LossLimitDocs;
